import Game from "./components/Game";

function App() {

  return (
    <div>
      <Game />
    </div>
  );
}

export default App;
